import { render } from "./HiFireNewDocForm.vue?vue&type=template&id=045289b3"
import script from "./HiFireNewDocForm.vue?vue&type=script&lang=js"
export * from "./HiFireNewDocForm.vue?vue&type=script&lang=js"

import exportComponent from "/vercel/path0/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__